module.exports = __webpack_public_path__ + "img/i_media_matrix-2.19184d92.png";